<!--
Author: TangChen
Date: 2018-09-25
Desc: 绘制提示信息卡片，为公共组件
 -->
<template>
    <div class="comp-hint-card comp clear">
        <div class="pwd-way-con">
            <span class="pwd-way-img" :class="[data.cla]">
                <i :class="data.icon" />
            </span>
            <div class="pwd-way-intr">
                <h3>{{ data.tit }}</h3>
                <p>{{ data.text }}</p>
            </div>
        </div>
        <div v-if="data.btnArr" class="pwd-way-btn">
            <el-button
                v-for="(btn,index) in data.btnArr"
                :key="index"
                :class="{'btn-m':data.btnArr.length>1}"
                type="yellow"
                :disabled="btn.disabled"
                v-on:click="returnBtn(btn.page,btn.way)"
            >
                {{ btn.btn }}
            </el-button>
        </div>
        <div v-if="doAll" class="img-icon">
        </div>
    </div>
</template>
<script>
export default {
    name: "HintCard",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
        };
    },
    computed: {
        doAll(){
            const _info = this.$cache.getUser();
            if(_info.needfillappro === "1" && this.data.btnArr[0].page === "infocollection"){
                return true;
            }
            if(_info.needfillcrs === "1" && this.data.btnArr[0].page === "taxeslist"){
                return true;
            }
            /*if(_info.needfillappro === "1" && this.data.btnArr[0].page === "modifyinfo"){
                return true;
            }*/
            if(_info.existbenef === "" && this.data.btnArr[0].page === "beneficiarylist"){
                return true;
            }
            return false;
        }
    },
    methods: {
        returnBtn (page, way) {
            this.$emit("btn-click", page, way);
        }
    }
};
</script>
<style lang="scss">
    .comp-hint-card {
        padding: 18px 30px 20px 26px;
        border-radius: 6px 6px;
        margin-top: 28px;
        position: relative;
        .img-icon{
            position: absolute;
            width: 64px;
            height: 46px;
            right: 0;
            top: 0;
        }
        .pwd-way-con {
            float: left;
            .pwd-way-img {
                width: 82px;
                height: 82px;
                display: inline-block;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                text-align: center;
                line-height: 82px;
                font-size: 40px;
                vertical-align: middle;
            }
            .pwd-way-intr {
                padding-left: 20px;
                display: inline-block;
                vertical-align: middle;
                line-height: 30px;
                h3 {
                    font-size: 16px;
                    font-weight: normal;
                }
            }
        }
        .pwd-way-btn {
            float: right;
            padding-top: 21px;
            .el-button {
                min-width: 170px;
                &.btn-m{min-width: 80px;}
            }
        }
    }
</style>
